module.exports = __webpack_public_path__ + "static/media/star2.4571e23d.svg";